import { render, staticRenderFns } from "./TransactionDetailFilesSection.vue?vue&type=template&id=bc4b5e1c"
import script from "./TransactionDetailFilesSection.vue?vue&type=script&lang=js"
export * from "./TransactionDetailFilesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports